import React from 'react';
import { useSelector } from 'react-redux';
import { Table } from '../index.js';
const MentionExplanation = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("th", null, lang.interactions.mention),
                React.createElement("th", null, lang.interactions.explanation),
                React.createElement("th", null, lang.interactions.example)),
            props.suggestions.map((suggestion) => (React.createElement("tr", { key: suggestion.field },
                React.createElement("td", null, '@' + suggestion.label),
                React.createElement("td", null, suggestion.description),
                React.createElement("td", null, suggestion.example)))))));
};
export default MentionExplanation;
//# sourceMappingURL=MentionExplanation.js.map